
// import $ from 'jquery'
import EVENTS from './upload-events'
import UPLOAD_STATUS from './upload-status'
import File from './upload-file'
import UploadRuntime from './upload-runtime-html5'


 function  Upload() {
    const DOMAIN_SERVICE = '//'+(location.host.indexOf('test') >=0?'test.':'')+'v-upload.huya.com/index.php'
    let currentRunTime = null
    let DEFAULT_SETTINGS = {
        runTimes: ["html5", "flash"],
        chunkSize: 10 * 1024 * 1024, //文件每片大小为10M,
        target: "",
        url: "http://localhost",
        maxErrorTimes: 3,
        filter: "video/*",
        validExts: [".wmv", ".avi", ".rm", ".rmvb", ".mpg", ".mpeg", ".3gp", ".mov", ".mp4", ".mkv", ".flv", ".ts"]
    }

    const jqDispatcher = $({})
    const files = {}
    const uploadedFiles = {}
    let settings = DEFAULT_SETTINGS
    const removeFile = function(fuid) {
        files[fuid] = null;
        delete files[fuid];
        uploadedFiles[fuid] = null;
        delete uploadedFiles[fuid];
    };

    function getDomain(fuid, callback) {
        $.getJSON(DOMAIN_SERVICE + "/?callback=?", {
            r: 'upload/getDomains',
            fuid: fuid
        }).done(function (json) {
            if (Number(json.code)) {
                callback('//' + json.result[0] + '/index.php');
            } else {
                callback('//' + window.UPLOAD_DOMAIN + '/index.php');
            }
        }).fail(function () {
            callback('//' +window.UPLOAD_DOMAIN+ '/index.php');
        });
    }

    return {
        init: function(o) {
            settings = $.extend(true, DEFAULT_SETTINGS, o)
            if (currentRunTime) {
                currentRunTime.init(settings),
                $(this).trigger(this.EVENTS.INITED);
            } else {
                //var runTimes = $.extend(!0, [], settings.runTimes)
                var me = this;
                var tempRunTime = new UploadRuntime()

                if (tempRunTime.check && tempRunTime.check()) {
                    currentRunTime = tempRunTime;

                    currentRunTime.on(EVENTS.INITED, function(evt) {
                        jqDispatcher.trigger(EVENTS.INITED);
                    });
                    currentRunTime.on(EVENTS.FILE_SELECTED, function(evt, fileInfo) {
                        me.onFileSelected(fileInfo);
                    });
                    currentRunTime.on(EVENTS.LOAD_PROGRESS, function(evt, fileInfo, bytesLoaded) {
                        me.onLoadProgress(fileInfo, bytesLoaded);
                    });
                    currentRunTime.on(EVENTS.LOAD_COMPLETE, function(evt, fileInfo) {
                        me.onLoadComplete(fileInfo);
                    });
                    currentRunTime.on(EVENTS.UPLOAD_COMPLETE, function(evt, fileInfo, speed, res) {
                        me.onUploadComplete(fileInfo, speed, res.code, res.next, res.msg);
                    });
                    currentRunTime.on(EVENTS.UPLOAD_ERROR, function(evt, fileInfo, code, msg) {
                        me.onUploadError(fileInfo, code, msg);
                    });
                    currentRunTime.on(EVENTS.IO_ERROR, function(evt, fileInfo, code, msg) {
                        me.onIOError(fileInfo, code, msg);
                    });

                    currentRunTime.init(settings);
                }

                // (function getRunTime() {
                //     if (!runTimes.length) return;
                //     var runTime = runTimes.shift();
                //     import("./upload-runtime-" + runTime).then(function(rt) {
                //         if (rt && typeof rt == "function") {
                //             var tempRunTime = new rt();
                //             if (tempRunTime.check && tempRunTime.check()) {
                //                 currentRunTime = tempRunTime;

                //                 currentRunTime.on(EVENTS.INITED, function(evt) {
                //                     jqDispatcher.trigger(EVENTS.INITED);
                //                 });
                //                 currentRunTime.on(EVENTS.FILE_SELECTED, function(evt, fileInfo) {
                //                     me.onFileSelected(fileInfo);
                //                 });
                //                 currentRunTime.on(EVENTS.LOAD_PROGRESS, function(evt, fileInfo, bytesLoaded) {
                //                     me.onLoadProgress(fileInfo, bytesLoaded);
                //                 });
                //                 currentRunTime.on(EVENTS.LOAD_COMPLETE, function(evt, fileInfo) {
                //                     me.onLoadComplete(fileInfo);
                //                 });
                //                 currentRunTime.on(EVENTS.UPLOAD_COMPLETE, function(evt, fileInfo, speed, res) {
                //                     me.onUploadComplete(fileInfo, speed, res.code, res.next, res.msg);
                //                 });
                //                 currentRunTime.on(EVENTS.UPLOAD_ERROR, function(evt, fileInfo, code, msg) {
                //                     me.onUploadError(fileInfo, code, msg);
                //                 });
                //                 currentRunTime.on(EVENTS.IO_ERROR, function(evt, fileInfo, code, msg) {
                //                     me.onIOError(fileInfo, code, msg);
                //                 });

                //                 currentRunTime.init(settings);
                //             } else {
                //                 if (runTimes.length) {
                //                     getRunTime();
                //                 }
                //             }
                //         } else {
                //             if (runTimes.length) {
                //                 getRunTime();
                //             }
                //         }
                //     });
                // })();
            }
        },
        on: function() {
            jqDispatcher.on.apply(jqDispatcher, arguments)
        },
        valid: function(fileInfo) {
            var ext = fileInfo.name.substring(fileInfo.name.lastIndexOf(".")).toLowerCase();
            return ext && $.inArray(ext, settings.validExts) >= 0 ? true : false
        },
        load: function(fileInfo, n) {
            n = n || 0
            fileInfo.fseq = n
            files[fileInfo.fuid] = fileInfo
            // currentRunTime.load(e.fuid),
           // files[e.fuid].status = UPLOAD_STATUS.LOADING,
            // jqDispatcher.trigger(EVENTS.UPLOAD_STARTED, [e])
            getDomain(e.fuid, function(url) {
                currentRunTime.setUrl(e.fuid, url)
                currentRunTime.load(e.fuid)
                files[e.fuid].status = UPLOAD_STATUS.LOADING
                jqDispatcher.trigger(EVENTS.UPLOAD_STARTED, [fileInfo])
            })
        },
        onFileSelected: function(fileInfo) {
            var file = new File(fileInfo, settings);
            if(this.valid(fileInfo)) {
                // getDomain(fileInfo.fuid, (url) => {
                //     window.UPLOAD_DOMAIN = url
                // })
                if(files[fileInfo.fuid]) {
                    jqDispatcher.trigger(EVENTS.UPLOADING, [file]) 
                } else if(uploadedFiles[fileInfo.fuid]){
                    jqDispatcher.trigger(EVENTS.UPLOADED, [file])
                } else {
                    jqDispatcher.trigger(EVENTS.FILE_SELECTED, [file])
                }
            } else {
                jqDispatcher.trigger(EVENTS.INVALID_FILE, [file])
            }
            
        },
        onLoadProgress: function(fileInfo, bytesLoaded) {
            files[fileInfo.fuid].status = UPLOAD_STATUS.LOADING,
            jqDispatcher.trigger(EVENTS.LOAD_PROGRESS, [files[fileInfo.fuid], bytesLoaded])
        },
        onLoadComplete: function(fileInfo) {
            var file = files[fileInfo.fuid];
            jqDispatcher.trigger(EVENTS.LOAD_COMPLETE, [n]);
            var me = this;
            if(file.fseq > file.fcks - 1) {
                uploadedFiles[fileInfo.fuid] = true
                currentRunTime.stop(fileInfo.fuid)

                files[fileInfo.fuid] = null 
                delete files[fileInfo.fuid]

                jqDispatcher.trigger(EVENTS.UPLOADED, [file])
            } else {
                files[fileInfo.fuid].status = UPLOAD_STATUS.UPLOADING, 
                me.send(fileInfo.fuid)
            }
                
        },
        onUploadComplete: function(fileInfo, speed, code) {
            var file = files[fileInfo.fuid];
            file.speed = speed,
            clearInterval(file.tId);
            var bytesUploaded = (file.fseq + 1) * settings.chunkSize;
            jqDispatcher.trigger(EVENTS.UPLOAD_COMPLETE, [file, bytesUploaded, speed, code])
        },
        onUploadError: function(fileInfo, code, msg) {
            var file = files[fileInfo.fuid];
            clearInterval(file.tId)
            if (++files[fileInfo.fuid].errorTimes >= settings.maxErrorTimes) {
                jqDispatcher.trigger(EVENTS.UPLOAD_ERROR, [new File(fileInfo, settings), msg])
                removeFile(fileInfo.fuid)
            } else {
                // 重试
                this.send(e.fuid)
            }
        },
        onIOError: function(fileInfo, code, msg) {
            jqDispatcher.trigger(EVENTS.IO_ERROR, [new File(fileInfo, settings), msg]),
            removeFile(fileInfo.fuid)
        },
        pause: function(fuid) {
            var file = files[fuid];
            clearInterval(file.tId),
            files[fuid].status = UPLOAD_STATUS.PAUSE,
            currentRunTime.abort(fuid)
        },
        resume: function(fuid) {
            files[fuid].status = UPLOAD_STATUS.UPLOADING,
            this.send(fuid)
        },
        stop: function(fuid) {
            var file = files[e];
            if(!file) return;
            clearInterval(file.tId),
            files[fuid].status = UPLOAD_STATUS.STOP,
            currentRunTime.stop(fuid);
            var temp  = $.extend(true, {}, files[fuid]);
            files[fuid] = null,
            delete files[fuid],
            jqDispatcher.trigger(EVENTS.UPLOAD_STOP, [temp])
            
        },
        send: function(fuid) {
            var file = files[fuid];
            if (file) {
                var params = {
                    fuid: file.fuid,
                    fname: file.name,
                    fseq: file.fseq + 1,
                    fcks: file.fcks,
                    fsize: file.size,
                    url: file.url
                };

                if (typeof settings.getParams == "function") {
                    params = settings.getParams(params);
                }

                currentRunTime.send(fuid, file.fseq, file.fcks, settings.chunkSize, params);

                
                // TODO
                file.startSendTime = new Date().valueOf();
                (function(file) {
                    file.tId = setInterval(function() {
                        var duration = (new Date().valueOf() - file.startSendTime) / 1000;
                        var speed = file.speed || (file.size / 1024) / duration;
                        var bytesUploaded;

                        if (speed * duration * 1024 > settings.chunkSize) {
                            speed = (settings.chunkSize / 1024) / duration;
                            bytesUploaded = Math.min((file.fseq + 1) * settings.chunkSize, file.size) - 1024;
                        } else {
                            bytesUploaded = Math.min(file.fseq * settings.chunkSize + speed * duration * 1024, file.size - 1024);
                        }

                        jqDispatcher.trigger(EVENTS.UPLOAD_PROGRESS, [file, bytesUploaded, speed]);
                    }, 1000);
                })(file);

            }
        },
        EVENTS: EVENTS,
        show: function() {
            currentRunTime && currentRunTime.show()
        },
        hide: function() {
            currentRunTime && currentRunTime.hide()
        }
    };
}


export default Upload()